import { createSlice, isAnyOf } from "@reduxjs/toolkit";
import { setIdolId, setCurrentIdol, clearSession } from './userSlice';

/**
 * 偶像上線狀態（見 docs/idol-online-plan.md §4）
 *
 * 只存 /idol/check-online 的結果 { [idolId]: boolean }；查詢時機、輪詢由
 * src/shared/utils/idolOnlineTracker.js 負責。不持久化（store.js 的 blacklist）。
 */
export const onlineSlice = createSlice({
  name: 'online',
  initialState: {
    byId: {},
  },
  reducers: {
    // payload：check-online 回傳的 data 陣列 [{ idol_id, is_online }]
    setOnlineStatuses(state, action) {
      action.payload.forEach(({ idol_id, is_online }) => {
        state.byId[idol_id] = is_online;
      });
    },
    // payload：查詢失敗的 idolId 陣列。清掉而不是保留舊值，避免顯示可能已過期的「在線」
    clearOnlineStatuses(state, action) {
      action.payload.forEach((idolId) => {
        delete state.byId[idolId];
      });
    },
  },
  extraReducers: (builder) => {
    // 換偶像、登出：觀看者身分改變，舊結果一律作廢
    builder.addMatcher(isAnyOf(setIdolId, setCurrentIdol, clearSession), (state) => {
      state.byId = {};
    });
  }
});

export const { setOnlineStatuses, clearOnlineStatuses } = onlineSlice.actions;
export default onlineSlice.reducer;
